import { useState, useEffect, useRef, useCallback } from 'react';

const FEED_URL =
  'https://api.coingecko.com/api/v3/simple/price' +
  '?ids=bitcoin,ethereum,solana,ripple&vs_currencies=usd';

/* Map every ticker/name a user might enter → CoinGecko id */
const TICKER_TO_ID = {
  BTC:      'bitcoin',
  BITCOIN:  'bitcoin',
  ETH:      'ethereum',
  ETHEREUM: 'ethereum',
  SOL:      'solana',
  SOLANA:   'solana',
  XRP:      'ripple',
  RIPPLE:   'ripple',
};

export function useCryptoFeed() {
  const [prices,     setPrices]     = useState({});          // { bitcoin: 67234, ... }
  const [feedStatus, setFeedStatus] = useState('loading');   // 'loading' | 'live' | 'offline'
  const lastPrices                  = useRef({});

  const fetchPrices = useCallback(async () => {
    try {
      const res = await fetch(FEED_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const next = Object.fromEntries(
        Object.entries(data).map(([id, v]) => [id, v.usd])
      );
      lastPrices.current = next;
      setPrices(next);
      setFeedStatus('live');
    } catch {
      // Keep last known prices; switch to offline indicator
      setPrices(lastPrices.current);
      setFeedStatus('offline');
    }
  }, []);

  useEffect(() => {
    fetchPrices();
    const timer = setInterval(fetchPrices, 60_000);
    return () => clearInterval(timer);
  }, [fetchPrices]);

  /** Return the live USD price for a position name, or null if not a tracked ticker. */
  function getLivePrice(name) {
    const id = TICKER_TO_ID[name?.toUpperCase?.()];
    return id != null ? (prices[id] ?? null) : null;
  }

  return { feedStatus, getLivePrice };
}
